<nav class="nav-main">
	<div class="nav-logo">
		<a [routerLink]="['/']">
			<app-fm-logo [prefix]="prefix"></app-fm-logo>
		</a>
		<a [routerLink]="['/']"><span>IKEA Media Content Centre</span></a>
	</div>

	<ul class="btn-section">
		<li>
			<button [routerLink]="['/search/images']" class="btn-circle" type="button">
				<app-ikea-icon
					iconName="search"
					[width]="iconSize"
					[height]="iconSize"
				></app-ikea-icon>
			</button>
		</li>

		<li>
			<app-user-collection-selector [iconSize]="iconSize">
			</app-user-collection-selector>
		</li>

		<li>
			<button [routerLink]="['/profile']" class="btn-circle" type="button">
				<app-ikea-icon
					iconName="human"
					[width]="iconSize"
					[height]="iconSize"
				></app-ikea-icon>
			</button>
		</li>
	</ul>
</nav>
